const formatRelativeDate = (dateStr) => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr; // fallback pour les anciennes valeurs texte
  const diffDays = Math.floor((Date.now() - date.getTime()) / 86_400_000);
  if (diffDays < 7)
    return `il y a ${Math.max(1, diffDays)}\u00a0jour${diffDays > 1 ? "s" : ""}`;
  const diffWeeks = Math.floor(diffDays / 7);
  if (diffWeeks < 5)
    return `il y a ${diffWeeks}\u00a0semaine${diffWeeks > 1 ? "s" : ""}`;
  const diffMonths = Math.round(diffDays / 30.44);
  if (diffMonths < 12) return `il y a ${Math.max(1, diffMonths)}\u00a0mois`;
  const diffYears = Math.max(1, Math.round(diffDays / 365.25));
  return `il y a ${diffYears}\u00a0an${diffYears > 1 ? "s" : ""}`;
};

const Avatar = ({ username, profilePictureUrl }) => {
  if (profilePictureUrl) {
    return (
      <img
        className="review__avatar review__avatar--img"
        loading="lazy"
        src={profilePictureUrl}
        alt={username}
      />
    );
  }
  return (
    <div className="review__avatar" aria-hidden="true">
      {username.charAt(0).toUpperCase()}
    </div>
  );
};

const StarRating = ({ rating }) => (
  <div className="review__stars" aria-label={`${rating} étoiles sur 5`}>
    {Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        className={`review__star ${i < rating ? "review__star--filled" : ""}`}
      >
        ★
      </span>
    ))}
  </div>
);

// Calcule le nombre de colonnes optimal selon le nombre d'avis :
// ≤3 avis → 1 ligne, N colonnes
// 4-6 avis → 2 lignes, ceil(N/2) colonnes (max 3)
// >6 avis  → 3 colonnes, lignes supplémentaires
const getCols = (count) => {
  if (count <= 3) return count;
  return Math.min(Math.ceil(count / 2), 3);
};

const ReviewsGrid = ({ reviews }) => {
  const cols = getCols(reviews.length);

  return (
    <div className="reviews-grid" style={{ "--reviews-cols": cols }}>
      {reviews.map((review) => (
        <div key={review.id} className="review">
          <div className="review__header">
            <Avatar
              username={review.username}
              profilePictureUrl={review.profilePictureUrl}
            />
            <div className="review__identity">
              <span className="review__username">{review.username}</span>
              <span className="review__submitted-at">
                {formatRelativeDate(review.submittedAt)}
              </span>
            </div>
          </div>
          <StarRating rating={review.rating} />
          <p className="review__text">{review.text}</p>
        </div>
      ))}
    </div>
  );
};

export default ReviewsGrid;
